import { IFieldConfig } from '../models/Table';

export const headerConfig: IFieldConfig[] = [
  { id: 'league', label: 'League', cardTitle: true },
  { id: 'match', label: 'Match' },
  // { id: 'date', label: 'Date' },
  // { id: 'time', label: 'Time' },
  { id: 'fullDate', label: 'Date', width: 135 },
  { id: 'avg', label: 'AVG', percent: true },
  { id: 'home', label: 'Home', percent: true },
  { id: 'away', label: 'Away', percent: true },
  { id: 'mutual', label: 'H2H', percent: true },
];

export const headerConfigPrediction: IFieldConfig[] = [
  { id: 'league', label: 'League', cardTitle: true },
  { id: 'match', label: 'Match' },
  { id: 'fullDate', label: 'Date', width: 135 },
  { id: 'classic', label: 'Classic', percent: true },
  { id: 'btts', label: 'BTTS', percent: true },
  { id: 'over_35', label: 'Over 3.5', percent: true },
  { id: 'over_25', label: 'Over 2.5', percent: true },
  // { id: 'home_over_05', label: 'HO 0.5', percent: true },
  // { id: 'home_over_15', label: 'HO 1.5', percent: true },
  // { id: 'away_over_05', label: 'AO 0.5', percent: true },
  // { id: 'away_over_15', label: 'AO 1.5', percent: true },
];
